module.exports = __webpack_public_path__ + "static/media/under-construction.c7b333e8.jpg";